import styled from 'styled-components'

export const Container = styled.div`
  width: 108px;
  min-height: 100px;
`

export const ButtonOpenMap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: auto;
  height: 27px;
  color: #FFF;
  background: rgba(17,36,38,0.7);
  padding: 0 8px;
  margin-left: auto;
  cursor: pointer;
`

export const TextRight = styled.p`
  margin: 0;
  color: #FFF;
  text-transform: uppercase;
  font-size: 9px;
  letter-spacing: .7px;
`
export const Titles = styled.div`
  margin-top: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
  line-height: 22px;
  padding-top: 4px;
  border-top: solid 1px white;
  
  > div {
    text-align: right;
    letter-spacing: .5px;
  }
`